const autoNgTemplateLoaderTemplate1 = require('./host-browser-view.html');

angular.module('portainer.docker').component('hostBrowserView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'HostBrowserViewController',
  bindings: {
    endpoint: '<',
  },
});
